<template>
  <v-card>
    <v-card-text>
      <h3>Attendance</h3>
      <v-toolbar flat>
        <template v-slot:extension>
          <v-tabs
              v-model="tabs"
              fixed-tabs
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab>
              Add
            </v-tab>
            <v-tab>
             Report
            </v-tab>
<!--            <v-tab>-->
<!--              Online class-->
<!--            </v-tab>-->

          </v-tabs>
        </template>
      </v-toolbar>
      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <take-attendance :academic_class="academic_class" :timetable="timetable" :courses="courses"></take-attendance>
        </v-tab-item>
        <v-tab-item>
          <attendance-report :academic_class="academic_class" :timetable="timetable" :courses="courses"></attendance-report>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import TakeAttendance from "@/view/pages/academic-class/summary/attendance/TakeAttendance";
import AttendanceReport from "@/view/pages/academic-class/summary/attendance/AttendanceReport";
import AttendanceOnlineReport from "@/view/pages/academic-class/summary/attendance/OnlineClassAttendance.vue";

export default {
  name: "Attendance",
  props:['timetable', 'courses','academic_class'],
  components:{
    TakeAttendance, AttendanceReport
  },
  data(){
    return{
      tabs:null
    }
  },
  methods:{

  }
}
</script>

<style scoped>

</style>
